<template>
  <v-dialog :value="show" @input="close" persistent width="560" scrollable>
    <v-card>
      <ModalHeader
        :title="'Edit Lead #' + form.id"
        icon="mdi-account-edit"
        @close="close"
      />
      <v-divider></v-divider>
      <v-card-text class="pa-4" style="max-height: 70vh">
        <v-form ref="form" class="mt-3">
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                outlined
                dense
                label="Customer Name *"
                v-model="form.customer_name"
                :rules="[(v) => !!v || 'Name is required']"
                prepend-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                outlined
                dense
                label="Contact Number *"
                v-model="form.contact_number"
                :rules="[(v) => !!v || 'Contact number is required']"
                prepend-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                outlined
                dense
                label="Source"
                v-model="form.lead_source_id"
                :items="customer_sources"
                item-text="name"
                item-value="id"
                prepend-icon="mdi-bullhorn"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                outlined
                dense
                label="Interested In *"
                v-model="form.category"
                :items="categories"
                :rules="[(v) => !!v || 'Pick a category']"
                prepend-icon="mdi-cart"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                outlined
                dense
                label="Grade"
                v-model="form.grade"
                :items="grades"
                prepend-icon="mdi-label"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex align-center">
              <v-switch
                v-model="form.converted"
                label="Converted to sale?"
                color="green"
                inset
                hide-details
                class="mt-0"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="6" v-if="form.converted">
              <v-text-field
                outlined
                dense
                label="Sale Amount (₱)"
                v-model="form.sale_amount"
                type="number"
                prepend-icon="mdi-cash"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-4 py-3">
        <v-btn color="warning" depressed @click="submit" :loading="loading"
          >Save</v-btn
        >
        <v-btn text @click="close">Cancel</v-btn>
        <v-spacer></v-spacer>
        <p class="caption grey--text mb-0">editLeadModal.vue</p>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
import { LEAD_CATEGORIES, LEAD_GRADES } from "@/config/leadCategoryTemplates";

export default {
  props: {
    show: { type: Boolean, default: false },
    lead: { type: Object, default: null },
  },
  data() {
    return {
      loading: false,
      customer_sources: [],
      categories: LEAD_CATEGORIES,
      grades: LEAD_GRADES,
      form: {},
    };
  },
  watch: {
    show(val) {
      if (val) this.init();
    },
  },
  methods: {
    ...mapActions({ update_lead: "lead/update_lead" }),
    async init() {
      this.form = { ...this.lead, converted: !!(this.lead && this.lead.converted) };
      if (this.customer_sources.length === 0) {
        try {
          const res = await axios.get("/customer_sources");
          this.customer_sources = res.data;
        } catch (e) {
          // non-fatal
        }
      }
    },
    close() {
      this.$emit("close");
    },
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        const payload = {
          ...this.form,
          sale_amount: this.form.converted ? this.form.sale_amount : null,
        };
        const updated = await this.update_lead(payload);
        this.$alert({
          title: "Success",
          message: "Lead updated.",
          color: "success",
          icon: "mdi-check-circle",
        });
        this.$emit("saved", updated);
        this.close();
      } catch (e) {
        this.$alert({
          title: "Error",
          message: e?.response?.data?.message || "Failed to update lead.",
          color: "error",
          icon: "mdi-alert-circle",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
